var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5 22.15C22.31 22.15 22.13 22.08 21.98 21.94L17.41 17.59C15.64 19.05 13.34 19.93 10.83 19.93C5.27 19.93 0.75 15.61 0.75 10.29C0.75 4.97002 5.27 0.650024 10.83 0.650024C16.39 0.650024 20.91 4.97002 20.91 10.29C20.91 12.68 20 14.87 18.49 16.55L23.01 20.86C23.31 21.15 23.32 21.62 23.04 21.92C22.89 22.07 22.69 22.15 22.5 22.15ZM10.83 2.15002C6.1 2.15002 2.25 5.80002 2.25 10.29C2.25 14.78 6.1 18.43 10.83 18.43C13.17 18.43 15.29 17.54 16.84 16.1C16.85 16.08 16.87 16.07 16.88 16.05C16.91 16.02 16.95 15.99 16.98 15.96C18.48 14.49 19.41 12.49 19.41 10.29C19.41 5.80002 15.56 2.15002 10.83 2.15002Z",
    fill: "#ACACAC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.d733bd1ba7d2d0235a964bd0d2f01d98.svg";
export { ForwardRef as ReactComponent };